import Store from './Store';
import { ProductConfigurator } from './views/ProductConfigurator';
import { ProductForPdf } from './views/ProductForPdf';
import { getUrlSearchParams } from './utils';
import './App.scss';

const urlParams = getUrlSearchParams();
const forPdf = urlParams.get('forPdf') === 'true';

function App() {
  return <Store>{forPdf ? <ProductForPdf /> : <ProductConfigurator />}</Store>;
}

export default App;
